<template>
  <el-form :model="autoForm" ref="form">
    <el-form-item
      :label-width="labelWidth"
      :rules="
        itemP.parameterType.parameterEditorType != 1 &&
        itemP.parameterType.parameterEditorType != 2
          ? itemP.parameterType.parameterValidatorType
          : undefined
      "
      :prop="`[${indexP}].value`"
      v-for="(itemP, indexP) in autoForm"
      :key="indexP"
      :label="itemP.parameterShowName"
    >
      <el-select
        :disabled="disabled || !itemP.canEdit"
        v-model="itemP.value"
        v-if="itemP.parameterType.parameterEditorType == 5"
      >
        <el-option
          v-for="(itemC, indexC) in itemP.availableChoiceValues"
          :key="indexC"
          :label="itemC.key"
          :value="itemC.value"
        />
      </el-select>

      <el-checkbox-group
        v-if="itemP.parameterType.parameterEditorType == 4"
        v-model="itemP.value"
      >
        <el-checkbox
          :disabled="disabled || !itemP.canEdit"
          :key="indexC"
          v-for="(itemC, indexC) in itemP.availableChoiceValues"
          :label="itemC.key"
          >{{ itemC.value }}</el-checkbox
        >
      </el-checkbox-group>
      <Keyboard
        v-else-if="itemP.parameterType.parameterEditorType == 0"
        v-model="itemP.value"
        :ip="itemP.ip || false" :disabled="disabled || !itemP.canEdit"
        
      >
        <el-input v-model="itemP.value" :disabled="disabled || !itemP.canEdit"
          ><template v-if="itemP.unitName" #append>{{
            itemP.unitName
          }}</template></el-input
        >
      </Keyboard>
      <el-switch
        :disabled="disabled || !itemP.canEdit"
        v-else-if="itemP.parameterType.parameterEditorType == 3"
        v-model="itemP.value"
      />
      <el-row v-else-if="itemP.parameterType.parameterEditorType == 2">
        <el-col :span="10">
          <el-form-item
            :rules="itemP.parameterType.parameterValidatorType"
            :prop="`[${indexP}].value.rangeBegin`"
          >
            <Keyboard v-model="itemP.value.rangeBegin" :disabled="disabled || !itemP.canEdit">
              <el-input v-model="itemP.value.rangeBegin" :disabled="disabled || !itemP.canEdit"
            /></Keyboard>
          </el-form-item> </el-col
        >&nbsp;-&nbsp;
        <el-col :span="10">
          <el-form-item
            :rules="itemP.parameterType.parameterValidatorType"
            :prop="`[${indexP}].value.rangeEnd`"
          >
            <Keyboard v-model="itemP.value.rangeEnd"  :disabled="disabled || !itemP.canEdit">
              <el-input v-model="itemP.value.rangeEnd" :disabled="disabled || !itemP.canEdit"
            /></Keyboard>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        v-else-if="itemP.parameterType.parameterEditorType == 1"
        :rules="itemP.parameterType.parameterValidatorType"
        :prop="`[${indexP}].myValue`"
      >
        <el-time-picker
          :disabled="disabled || !itemP.canEdit"
          is-range
          v-model="itemP.myValue"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
          format="HH:mm"
        >
        </el-time-picker>
      </el-form-item>
      <!-- <el-form-item v-if="itemP.enable != undefined" label=""> </el-form-item> -->
      <el-form-item v-if="itemP.enable != undefined" label="状态">
        <el-switch v-model="itemP.enable" :disabled="disabled || !itemP.canEdit" />
      </el-form-item>
    </el-form-item>
  </el-form>
</template>

<script>
import Keyboard from "@/components/keyboard/index.vue";

export default {
  name: "Page",
  props: [
    "autoParameterMetaData",
    "autoProp",
    "autoForm",
    "labelWidth",
    "disabled",
  ],
  components: { Keyboard },
  data() {
    return {
      rules: {
        days: [
          {
            required: true,
            message: "必填",
          },
        ],
      },
    };
  },
  methods: {},
  mounted() {
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
